import { createContext } from 'react'

import { AccountStatisticContextValue } from './interface'

export const AccountStatisticContext = createContext<
  AccountStatisticContextValue | undefined
>(undefined)
